import React from "react";
import moment from "moment";
import { Button, Chip } from "@mui/material";

import { BG_COLORS } from "../../../constants";
import { TBrandEligibilityItem } from "../../../services/apiV2.types";
import { ResultRow } from "./ResultRow";

type Props = {
  item: TBrandEligibilityItem;
  applying: boolean;
  onApplied: (brandId: string) => void;
};

const badgeSx = { fontWeight: 600, height: 20 };

/** A row in the Ungated / Approval required / Not eligible tabs: a scanned brand or one of the user's own checks. */
export const BrandRow: React.FC<Props> = ({ item, applying, onApplied }) => {
  const isManual = item.source === "manual";

  return (
    <ResultRow
      testId="brand-row"
      asin={item.asin}
      brand={item.brandName}
      title={item.title}
      imageUrl={item.imageUrl}
      status={item.status}
      approvalLink={item.approvalLink}
      message={item.message}
      meta={`checked ${moment(item.checkedAt).fromNow()}`}
      badges={
        <>
          {item.isNew && (
            <Chip label="New" size="small" sx={{ ...badgeSx, bgcolor: BG_COLORS.success }} />
          )}
          {isManual && (
            <Chip label="Your check" size="small" variant="outlined" sx={badgeSx} />
          )}
        </>
      }
      actions={
        // "I applied" re-checks a scanned brand tonight; the user's own ASINs are re-checked by checking them again.
        item.status === "approval_required" && !isManual ? (
          item.appliedAt ? (
            <Chip label="Re-checking tonight" size="small" sx={{ bgcolor: BG_COLORS.info }} />
          ) : (
            <Button
              variant="outlined"
              size="small"
              disabled={applying}
              onClick={() => onApplied(item.brandId)}
            >
              I applied
            </Button>
          )
        ) : undefined
      }
    />
  );
};

export default BrandRow;
